import { useQuery } from '@lichtblick/apollo';
import { GetMyselfQuery, GetUserUserPayloadModel } from '@lichtblick/types';
import { useLogoutOnApolloError } from '@lichtblick/utils';

import { GET_MYSELF } from '../graphql/user';

export const useCurrentUser = () => {
  const { data: response, error } = useQuery<GetMyselfQuery>(GET_MYSELF);

  useLogoutOnApolloError(error);

  return { myself: response?.getUser_V1.data as GetUserUserPayloadModel };
};
